export default __webpack_public_path__ + "static/media/img.05312009.png";